import React, { Component } from "react";
import { Modal, Button, Tabs, Tab } from "react-bootstrap";
import Alert from "react-s-alert";
import SalesPersonTasksService from "../utils/SalesPersonTasksService";

class ManageTagsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      types: [],
      loading: true,
      newType: "",
      editingType: null,
      editingValue: ""
    };

    this.handleDeleteType = this.handleDeleteType.bind(this);
    this.handleCreateType = this.handleCreateType.bind(this);
    this.handleNewTypeChange = this.handleNewTypeChange.bind(this);
  }

  componentDidMount() {
    this.fetchTypes();
  }

  fetchTypes() {
    SalesPersonTasksService.getOptions()
      .then(data => {
        this.setState({
          types: data.types || [],
          loading: false
        });
      })
      .catch(error => {
        Alert.error("Failed to load types");
        this.setState({ loading: false });
      });
  }

  handleNewTypeChange(event) {
    this.setState({ newType: event.target.value });
  }

  handleCreateType(event) {
    event.preventDefault();
    
    const newType = this.state.newType.trim();
    if (!newType) {
      Alert.error("Type name cannot be empty");
      return;
    }

    if (this.state.types.includes(newType.toLowerCase())) {
      Alert.error("Type already exists");
      return;
    }

    // Create type in database
    SalesPersonTasksService.createType(newType)
      .then(response => {
        Alert.success(response.message || `Type "${newType}" created successfully`);
        this.setState({ newType: "" });
        this.fetchTypes();
        
        // Notify parent to refresh
        if (this.props.onTypesUpdated) {
          this.props.onTypesUpdated();
        }
      })
      .catch(error => {
        const errorMsg = error.response && error.response.data && error.response.data.error
          ? error.response.data.error
          : "Failed to create type";
        Alert.error(errorMsg);
      });
  }

  handleDeleteType(type) {
    if (!window.confirm(`Are you sure you want to delete the type "${type}"? This will remove it from all tasks.`)) {
      return;
    }

    SalesPersonTasksService.deleteType(type)
      .then(() => {
        Alert.success(`Type "${type}" deleted successfully`);
        this.fetchTypes();
        
        // Notify parent to refresh
        if (this.props.onTypesUpdated) {
          this.props.onTypesUpdated();
        }
      })
      .catch(error => {
        const errorMsg = error.response && error.response.data && error.response.data.error
          ? error.response.data.error
          : "Failed to delete type";
        Alert.error(errorMsg);
      });
  }

  render() {
    const { onClose } = this.props;
    const { types, loading, newType } = this.state;

    // System types that cannot be deleted
    const systemTypes = [
      'Incomplete Sale',
      'Sales Overdue'
    ];

    const isSystemType = (type) => systemTypes.includes(type);

    return (
      <Modal show={true} onHide={onClose} bsSize="large">
        <Modal.Header closeButton>
          <Modal.Title>Manage Types</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading ? (
            <div style={{ textAlign: "center", padding: "20px" }}>Loading...</div>
          ) : (
            <div>
              <h4>Task Types</h4>
              <p className="text-muted">
                Create, view, and delete types for organizing your tasks.
              </p>

              <div style={{ marginBottom: "20px" }}>
                <h5>Create New Type</h5>
                <form onSubmit={this.handleCreateType} style={{ display: "flex", gap: "10px" }}>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter new type name"
                    value={newType}
                    onChange={this.handleNewTypeChange}
                    style={{ flex: 1 }}
                  />
                  <Button type="submit" bsStyle="success">
                    <i className="fa fa-plus"></i> Add Type
                  </Button>
                </form>
              </div>

              <h5>Existing Types ({types.length})</h5>
              {types.length > 0 ? (
                <div style={{ 
                  maxHeight: "300px", 
                  overflowY: "auto", 
                }}>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                    {types.map(type => {
                      const isSystem = isSystemType(type);
                      return (
                        <span 
                          key={type}
                          className="label label-default"
                          style={{
                            fontSize: "14px",
                            padding: "6px 10px",
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "8px",
                            cursor: "default",
                            backgroundColor: "#e9ecef",
                            color: "#333",
                            border: "1px solid #ced4da"
                          }}
                        >
                          {type}
                          {!isSystem && (
                            <i 
                              className="fa fa-times-circle"
                              onClick={() => this.handleDeleteType(type)}
                              style={{
                                cursor: "pointer",
                                opacity: 0.6,
                                fontSize: "16px",
                                color: "#dc3545"
                              }}
                              onMouseEnter={(e) => e.target.style.opacity = 1}
                              onMouseLeave={(e) => e.target.style.opacity = 0.6}
                              title={`Delete type "${type}"`}
                            />
                          )}
                          {isSystem && (
                            <i 
                              className="fa fa-lock"
                              style={{
                                fontSize: "12px",
                                color: "#6c757d",
                                opacity: 0.5
                              }}
                              title="System type - cannot be deleted"
                            />
                          )}
                        </span>
                      );
                    })}
                  </div>
                </div>
              ) : (
                <div>
                  No types have been created yet. Create your first type above.
                </div>
              )}
            </div>
          )}
        </Modal.Body>
      </Modal>
    );
  }
}

export default ManageTagsModal;
